export const USERS_APP = "users";
export const SENSOR_APP = "sensor";
export const NOTIFICATION_APP = "notification";
export const CONFIGURATION_APP = "configuration";
export const COMMAND_APP = "command";
